// getters
const schoolroutesRoutes = state => state.schoolroutesRoutes

export default {
  schoolroutesRoutes
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/routes/getters.js